import { render, staticRenderFns } from "./index.vue?vue&type=template&id=24e20efb&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=24e20efb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e20efb",
  null
  
)

export default component.exports